// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const checkAllObjectValuesNull = (obj: any) => {
  // Get an array of the object's values
  const values = Object.values(obj);

  // If the object is empty, it technically has no non-null values
  if (values.length === 0) {
    return true;
  }

  // Check if every value in the array is strictly equal to null
  return values.every((value) => value === null);
};
